export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/teacher-c772606682b1bd1c3fde0bbea93a4f2d.svg";